import { Injectable } from '@angular/core';
import * as _moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor() { }

  filter(searchText, items, searchKeys, componentname?) {
    console.log({ searchText, items, searchKeys })
    const filteredData = items.filter((item) => {
      // console.log("first item", item);

      if (componentname == "newfilter") {
        return searchKeys.some(key => {
          // console.log("DATA", item[key] , key);

          return item[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())
        });
      }
      else if (componentname == 'accident') {

        return searchKeys.some(key => {

          if (key == 'createdBy') {
            //  return item[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())

            if (item[key] && item[key].user && item[key].user.name) {
              return item[key].user.name.toString().toLowerCase().includes(searchText.toString().toLowerCase())
            }
            else if (item[key] && item[key].createdBy && item[key].createdBy) {
              return item[key].createdBy.name.toString().toLowerCase().includes(searchText.toString().toLowerCase())
            }
            else if (item[key] && item[key].name) {
              return item[key].name.toString().toLowerCase().includes(searchText.toString().toLowerCase())
            }
          }
          else {

            return item[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())

          }


        }
        );

      } else if (componentname == 'asset') {
        return searchKeys.some(key => {
          if (key == 'locate') {
            console.log("SINGLE KEY", key, item['what3words']);
            if (item['what3words'].what3words) {
              return item['what3words'].what3words.toString().toLowerCase().includes(searchText.toString().toLowerCase())
            }
          }
          else {
            return item[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())
          }
        }
        );
      }
      else {

        if (item && item.assignment) {

          for (let i = 0; i < searchKeys.length; i++) {
            let key = searchKeys[i];
            console.log("item[key] ", item.assignment[key], " ******** ", item.assignment[key].toString().toLowerCase())
            // console.log("searchText", searchText, " ******** " , searchText.toString().toLowerCase())
            if (item.assignment[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())) {
              return true
            }
            else {
              return false;
            }
          }
        } else {
          for (let i = 0; i < searchKeys.length; i++) {
            let key = searchKeys[i];
            console.log("item[key] ", item[key], key)
            // console.log("searchText", searchText, " ******** " , searchText.toString().toLowerCase())
            if (item[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())) {
              return true
            }
            else {
              return false;
            }
          }
        }

      }
    });
    return filteredData;
  }



  filter1(searchText, items, searchKeys) {
    console.log({ searchText, items, searchKeys })
    const filteredData = items.filter((item) => {
      // console.log("first item", item);
      for (let i = 0; i < searchKeys.length; i++) {
        let key = searchKeys[i];
        // console.log("item[key] ", item[key], " ******** ", item[key].toString().toLowerCase())
        // console.log("searchText", searchText, " ******** " , searchText.toString().toLowerCase())
        // if (item.name.toString().toLowerCase().includes(searchText.toString().toLowerCase()) || item.alias.toString().replace(/ /g, '').toLowerCase().includes(searchText.toString().toLowerCase())) {
        //   return true
        // }
        // else {
        //   return false;
        // }

        if ((item && item.name && item.name.toString().toLowerCase().includes(searchText.toString().toLowerCase())) || (item && item.title && item.title.toString().toLowerCase().includes(searchText.toString().toLowerCase())) || (item && item.sentinelNumber && item.sentinelNumber.toString().toLowerCase().includes(searchText.toString().toLowerCase())) || (item && item.alias && item.alias.toString().replace(/ /g, '').toLowerCase().includes(searchText.toString().toLowerCase()))) {
          return true
        }
        else {
          return false;
        }

      }
    });
    return filteredData;
  }




  staffFilterService(searchText, items, searchKeys) {

    console.log("WHAT IS IN THE ITEM", items)
    const filteredData = items.filter((item) => {

      return searchKeys.some(key => {
        // console.log("here is the search keys...", key)
        if (key == 'name') {
          return item[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())
        }
        else if (key === 'fullName') {
          // console.log("SINGLE ITEM DATA", item.details.personlDetails[key], searchText)
          if ((item && item.details && item.details.personlDetails && item.details.personlDetails[key].toString().toLowerCase().includes(searchText.toString().toLowerCase()))) return true
          else return false
        }
        else if (key === 'ppeName') {
          if ((item && item.details && item.details[key].toString().toLowerCase().includes(searchText.toString().toLowerCase()))) return true
          else return false
        }

        else if (key == 'alias' || key == 'title' || key == 'category') {
          let compData = item.competencies

          let result = compData.filter(function (comp, index) {
            if (comp[key]) {
              return comp[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())
            }
          })


          if (result.length) {
            return true
          }
          else {
            return false
          }

        }


        else if (key == 'role') {
          let roleData = item.userId.userRole
          roleData.forEach(function (userrole, i) { if (userrole == 'mp') roleData[i] = "Medical Practitioner"; });
          // console.log("here is the role array ", roleData)

          let roleResult = roleData.filter(function (role, index) {

            roleData.forEach(function (userrole, i) { if (userrole == 'Medical Practitioner') roleData[i] = "mp"; });

            return role.toString().toLowerCase().includes(searchText.toString().toLowerCase())
          })


          // console.log("here rolr result", roleResult)
          if (roleResult.length) {
            return true
          }
          else {
            return false
          }

        } else if (key === 'sentinelNumber') {
          return item[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())
        }
        else if (key === 'newSentinelNumber') {
          console.log("THIS IS THE SINGLE ITEM", item)
          // return item[key].toString().toLowerCase().includes(searchText.toString().toLowerCase())
          if ((item && item.details && item.details.personlDetails && item.details.personlDetails['sentinelNumber'].toString().toLowerCase().includes(searchText.toString().toLowerCase()))) return true
          else return false
        }
      });
    });
    return filteredData;

  }



  timesheetFilter(searchText, items, searchKeys) {
    console.log({ searchText, items, searchKeys })
    const filteredData = items.filter((item) => {
      // console.log("first item", item);
      for (let i = 0; i < searchKeys.length; i++) {
        let key = searchKeys[i];
        if ((item && item.user.name && item.user.name.toString().toLowerCase().includes(searchText.toString().toLowerCase()))) {
          return true
        } else if ((item && item.user.sentinelNumber && item.user.sentinelNumber.toString().toLowerCase().includes(searchText.toString().toLowerCase()))) {
          return true
        }
        else {
          return false;
        }

      }
    });
    return filteredData;
  }


  // FILTER ON LABOUR JOB MODULE

  labourjobFilter(searchText, items, searchKeys) {
    const filteredData = items.filter((item) => {
      // console.log("ITEM", item)
      return searchKeys.some(key => {
        if (key == 'competency') {
          return item[key].title.toString().toLowerCase().includes(searchText.toString().toLowerCase())
        } else if (key == 'operatives') {
          let userData = item.operatives
          let result = userData.filter(function (comp, index) {
            return comp.name.toString().toLowerCase().includes(searchText.toString().toLowerCase())
          })
          if (result.length) {
            return true
          }
          else {
            return false
          }
        } else if (key == 'title') {
          return item.jobTitle.toString().toLowerCase().includes(searchText.toString().toLowerCase())
        }
        else if (key == 'location' && (item && item.jobLocation)) {
          return item.jobLocation.title.toString().toLowerCase().includes(searchText.toString().toLowerCase())
        } else if (key == 'joboperative') {
          // console.log("THis is item", item)
          let userData = item.operativeList
          let result = userData.filter(function (comp, index) {
            return comp.name.toString().toLowerCase().includes(searchText.toString().toLowerCase())
          })
          if (result.length) {
            return true
          }
          else {
            return false
          }
        }
      });
    });
    return filteredData;
  }


  dateFilterJobwise(jobList, dateRange) {
    let filteredData = []
    const startingDate = _moment(dateRange.startDate).format('MM/DD/YYYY')
    const endingDate = _moment(dateRange.endDate).format('MM/DD/YYYY')
    console.log("START DATE AND END DATE", startingDate, endingDate)
    jobList.filter((x) => {
      // console.log("SINGLE JOB VALUE", x)
      const start = this.checkDate(startingDate, endingDate, x.startDate)
      const end = this.checkDate(startingDate, endingDate, x.endDate)
      // const start = x.startDate.isBetween(startingDate, endingDate);
      // const end = x.endDate.isBetween(startDate, endDate);
      // console.log("JOB BETWEEN DATES", x.jobTitle, start, x.startDate, end, x.endDate)
      if (start || end) filteredData.push(x)
    })
    console.log("THIS IS THE FINAL FILTERDATA", filteredData)
    return filteredData
  }


  checkDate(fromDate, toDate, checkDate) {
    let dateFrom = fromDate
    let dateTo = toDate
    let dateCheck = checkDate
    let d1 = dateFrom.split("/");
    let d2 = dateTo.split("/");
    let c = dateCheck.split("/");
    let from = new Date(d1);  // -1 because months are from 0 to 11
    let to = new Date(d2);
    let check = new Date(c);
    const checkFlag = check <= from && check >= to
    return check >= from && check <= to
  }


}
